import React, { useEffect, useState } from "react";
import Logo from "../assets/logo.png";
import axios from 'axios';
import { Link } from "react-router-dom";

const ResetPasswordForm = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [token, setToken] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isTokenValid, setIsTokenValid] = useState(null);
  const [isPasswordReset, setIsPasswordReset] = useState(false);

  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const token = params.get("token");
    if (!token) {
      console.log("Invalid token");
      setError("Invalid token");
      setIsLoading(false);
      return;
    }
    console.log("Token:", token);
    setToken(token);
    if (token) {
      // Check if the token is valid
      axios.get(`${process.env.REACT_APP_SERVER_ADDRESS}/api/pass/check-token/${token}`)
        .then(response => {
          if (response.status === 200) {
            setIsTokenValid(true);
          }
        })
        .catch(error => {
          console.error('Error checking token:', error);
          setIsTokenValid(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, []);

  async function resetPassword(e) {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_ADDRESS}/api/pass/reset-password/${token}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ password }),
        }
      );

      if (response.ok) {
        // alert("Password reset successfully");
        setIsPasswordReset(true);
        setError(null);
      } else {
        switch (response.status) {
          case 400:
            console.log("Invalid or expired token");
            setError("Invalid or expired token");
            break;
          case 500:
            console.log("Server error");
            setError("Server error");
            break;
          default:
            console.log("Error resetting password");
            setError("Error resetting password");
        }
      }
    } catch (error) {
      console.error("Error resetting password:", error);
      setError("Error resetting password");
    } finally {
      setIsLoading(false);
    }
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#131313] font-roboto text-white">
        <div role="status" className="flex justify-center items-center space-x-2">
          <svg aria-hidden="true" className="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
          </svg>
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#131313] font-roboto text-white">
    {!isPasswordReset ? (
  isTokenValid === false ? (
    <div className="text-center">
      <Link to="/">
        <div className="text-center">
          <img src={Logo} alt="logo" className="mx-auto w-12 mb-4" />
        </div>
      </Link>
      <h1 className="text-3xl font-bold mb-4">Session Expired</h1>
      <p className="text-xl w-[40rem]">
        Your session has expired. Please try again with your request.
      </p>
    </div>
  ) : (
    <div className="w-full max-w-md p-8 space-y-6">
      <div className="text-center">
        <img src={Logo} alt="logo" className="mx-auto w-12 mb-4" />
        <h2 className="text-2xl font-bold font-dm-sans">Reset Your Password</h2>
      </div>
      <form onSubmit={resetPassword} className="space-y-4">
        <div>
          <label htmlFor="password" className="sr-only">
            New Password
          </label>
          <input
            id="password"
            name="password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="appearance-none rounded-md relative block w-full px-3 py-2 border placeholder-gray-400 text-gray-700 focus:outline-none focus:ring-[#493676] focus:border-[#493676] sm:text-sm"
            placeholder="Enter your new password"
          />
        </div>
        <div>
          <label htmlFor="confirm-password" className="sr-only">
            Confirm Password
          </label>
          <input
            id="confirm-password"
            name="confirm-password"
            type="password"
            required
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="appearance-none rounded-md relative block w-full px-3 py-2 border placeholder-gray-400 text-gray-700 focus:outline-none focus:ring-[#493676] focus:border-[#493676] sm:text-sm"
            placeholder="Confirm your new password"
          />
        </div>
        {error && (
          <div className="text-red-500 text-sm mt-2">{error}</div>
        )}
        <button
          type="submit"
          className={`w-full py-2 px-4 border border-transparent rounded-full shadow-sm text-white font-bold  ${
            isLoading ? 'bg-[#493676]/50' : 'bg-[#493676]'
          }`}
          disabled={isLoading}
        >
          {isLoading ? (
            <div role="status" className="flex justify-center items-center space-x-2">
              <svg aria-hidden="true" className="inline w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            "Reset Password"
          )}
        </button>
      </form>
    </div>
  )
) : (
  <div className="text-center">
    <Link to="/">
      <div className="text-center">
        <img src={Logo} alt="logo" className="mx-auto w-12 mb-4" />
      </div>
    </Link>
    <h1 className="text-3xl font-bold mb-4">Password Reset</h1>
    <p className="text-xl w-[40rem]">
      Your password has been successfully reset. You can now login with your new password.
    </p>
  </div>
)}

    </div>
  );
};

export default ResetPasswordForm;
